module.exports = __webpack_public_path__ + "img/mark.fcc63ea9.svg";